import { AfterViewInit, Component, ElementRef, HostListener, ViewChild, OnInit } from '@angular/core';
import { User } from '../_models/user';
import { UserService } from '../_services/user.service';
import { first } from 'rxjs/operators';
import { AppService } from './../appservice.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import * as _moment from 'moment';
import { CurrencyPipe } from '@angular/common';
import { format } from 'util';

const moment = _moment;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [CurrencyPipe]
})
export class HomeComponent implements OnInit, AfterViewInit {
  users: User;
  curdate = new Date();
  selectedGroup = 'item';
  selecteddate = this.getMonthDateRange(this.curdate.getFullYear(), this.curdate.getMonth() + 1);

  // Chart view used by ngx-charts [view]="view"
  view: [number, number] = [700, 320];

  @ViewChild('chartsContainer', { static: false }) chartsContainer!: ElementRef;

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Total Sales';
  showYAxisLabel = true;
  yAxisLabel = 'Date';
  timeline = true;
  animations = true;
  legendTitle = 'Legend';
  explodeSlices = false;
  doughnut = false;
  arcWidth = 0.25;
  tooltipDisabled = false;
  autoScale = true;


  multi: any[] = [
    {
      name: 'Sales',
      series: [
      ]
    }
  ];
  nums = [
    { name: 'year', value: '0.00' }, { name: 'month', value: '0.00' }, { name: 'week', value: '0.00' },
    { name: 'Yesterday', value: '0.00' }, { name: 'Today', value: '0.00' }
  ];
  salesitems = [];
  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };
  currentYear = moment().format('YYYY');
  lastYear = moment().subtract(1, 'year').format('YYYY');
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'This Year': [moment().subtract(1, 'year').startOf('month'), moment().endOf('month')]
  };
  formatting: any;

  constructor(private userService: UserService, private currencyPipe: CurrencyPipe, private service: AppService, private router: Router) {
    this.users = new User();
    this.ranges['Year ' + this.currentYear] = [moment().startOf('year'), moment().endOf('year')];
    this.ranges['Year ' + this.lastYear] = [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')];
    this.formatting = this.format.bind(this);
    // Object.assign(this, { single })
  }

  DateSelected(event) {
    this.loadreport();
  }

  loadreport() {
    this.service.getRequest('api/home/saleschart?start=' + this.selecteddate.start.format('YYYY-MM-DD HH:mm:ss')
      + '&end=' + this.selecteddate.end.format('YYYY-MM-DD HH:mm:ss') + '&group=' + this.selectedGroup).subscribe(x => {
        // Object.assign(this, { x });
        // this.singlechart = x;
        this.multi[0].series = [];
        x.sales.forEach(element => {
          this.multi[0].series.push(element);
        });
        this.salesitems = x.items;
        this.multi = [...this.multi];
        console.log(this.multi);
      });
    this.service.getRequest('api/home/sales_ymt').subscribe(x => {
      x = x[0];
      this.nums = [];
      this.nums.push({ name: 'Today', value: this.format(x.Today) });
      this.nums.push({ name: 'Yesterday', value: this.format(x.Yesterday) });
      this.nums.push({ name: 'Week', value: this.format(x.week) });
      this.nums.push({ name: 'Month', value: this.format(x.month) });
      this.nums.push({ name: 'Year', value: this.format(x.year) });
      console.log(this.nums);
    });
  }
  ngOnInit() {
    this.userService.getAll().pipe(first()).subscribe(users => {
      this.users = users;
    });

    this.loadreport();
  }

  ngAfterViewInit(): void {
    this.updateChartView();
    // allow initial change detection to settle
    setTimeout(() => this.updateChartView(), 50);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateChartView();
  }

  private updateChartView() {
    try {
      let containerWidth = window.innerWidth;
      if (this.chartsContainer && this.chartsContainer.nativeElement && this.chartsContainer.nativeElement.clientWidth) {
        containerWidth = this.chartsContainer.nativeElement.clientWidth;
      }
      const chartWidth = Math.max(300, Math.floor(containerWidth * 0.45));
      const chartHeight = Math.max(240, Math.floor(chartWidth * 0.45) + 200); // keep a decent aspect
      this.view = [chartWidth, chartHeight];
    } catch (e) {
      // fallback: keep default view
    }
  }

  onSelect(event) {
    console.log(event);
  }

  onLegendLabelClick(entry) {
    console.log('Legend clicked', entry);
  }
  changeGrouping(event) {
    const target = event.source.selected._element.nativeElement;
    this.selectedGroup = event.value;
    this.loadreport();
  }

//   pieTooltipText({ data }) {
//     const label = data.name;
//     const val = format(data.value);
// console.log( this.service.currency_sym + (new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(data.value)));
//     return `
//       <span class="tooltip-label">${label}</span>
//       <span class="tooltip-val">${val}</span>
//     `;
//   }
  format(x) {
    return isNaN(x) ? x : this.service.currency_sym + (new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(x));
  }
  getMonthDateRange(year, month) {
    // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
    // array is 'year', 'month', 'day', etc
    const startDate = moment([year, month - 1]);

    // Clone the value before .endOf()
    const endDate = moment(startDate).endOf('month');

    // make sure to call toDate() for plain JavaScript date type
    console.log({ start: startDate, end: endDate });
    return { start: startDate, end: endDate };
  }
}
